/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { SignInError } from '../../core/error/SignInError';
import {
    CLEAR_SIGN_IN_ERROR,
    SET_NEW_CODE_BTN_HIGHLIGHT,
    SET_LICENSE_PLATE_URL,
    SET_LP_CODE_AND_EXPIRATION,
    SET_SIGN_IN_ERROR,
} from './signin.types';
import { LpExpiredError } from '../../core/error/LpExpiredError';

export const clearSignInErrorAction = (): AnyAction => ({
    type: CLEAR_SIGN_IN_ERROR,
    payload: {
        error: undefined,
        hasError: false,
    },
});

export const setLicensePlateUrlAction = (licensePlateUrl: string | undefined): AnyAction => ({
    type: SET_LICENSE_PLATE_URL,
    payload: {
        licensePlateUrl,
    },
});

export const setLpCodeAndExpirationTimeAction = (
    licensePlateCode: string,
    lpExpirationTime: number,
): AnyAction => ({
    type: SET_LP_CODE_AND_EXPIRATION,
    payload: {
        licensePlateCode,
        lpExpirationTime,
    },
});

export const setSignInErrorAction = (error: LpExpiredError | SignInError): AnyAction => ({
    type: SET_SIGN_IN_ERROR,
    payload: {
        error,
        hasError: true,
    },
});

export const setSignInButtonHighlightAction = (value: boolean): AnyAction => ({
    type: SET_NEW_CODE_BTN_HIGHLIGHT,
    payload: {
        isButtonHighlight: value,
    },
});
